export const deposit = {
	code: 'IBD',
	description: 'Banca por internet o depósito',
};

export const creditCard = {
	code: 'CDC',
	description: 'Tarjeta de crédito o débito',
};

export const transfer = {
	code: 'TB',
	description: 'Transferencia bancaria',
};

export const reciveAndPay = {
	code: 'PPR',
	description: 'paga tu producto al recibir',
};

export default {
	creditCard: {
		code: 'CDC',
		description: 'Tarjeta de crédito o débito',
	},
	reciveAndPay: {
		code: 'PPR',
		description: 'paga tu producto al recibir',
	},
	deposit: {
		code: 'IBD',
		description: 'Banca por internet o depósito',
	},
	transfer: {
		code: 'TB',
		description: 'Transferencia bancaria',
	},
};



// WEBPACK FOOTER //
// ./src/shared/enums/wayPayment.js